import { gql } from 'graphql-request';

export const CreateLike = gql`
  mutation CreateLike($like:CreateLikeInput!) {
    createLike(input:$like) {
      id
      userId
      likeableId
      likeableType
      user {
        firebaseUserId
      }
      errors {
        fieldName
        errors
      }
    }
  }
`;

export const DestroyLike = gql`
  mutation DestroyLike($like:DestroyLikeInput!) {
    destroyLike(input:$like) {
      id
      userId
      likeableId
      likeableType
      errors {
        fieldName
        errors
      }
    }
  }
`;
